<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-knowledge">

        <page-title :title="'Wiedza'" :back="false"></page-title>

        <ion-list>
            <div v-for="(item,index) in navigation" :key="item.route" style="background: #f2f2f2">
                <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*100)">
                    <ion-item v-show="show" mode="ios" class="ion-activatable" :disabled="item.disabled" @click="goTo(item.route)">
                        <ion-thumbnail v-if="item.icon" slot="start" style="width: 25px; text-align:center">
                            <svg class="icon-inner" style="width: 25px; height: 55px;">
                                <use :xlink:href="'#'+item.icon"></use>
                            </svg>
                        </ion-thumbnail>
                        <ion-label mode="md" class="ion-text-wrap">
                            <h3>{{ item.title }}</h3>
                            <p>{{ item.content }}</p>
                            <svg class="icon icon-chevron-right" style="position: absolute; bottom: 8px; right: -2px; opacity: 0.5"><use xlink:href="#icon-chevron-right"></use></svg>
                        </ion-label>
                    </ion-item>
                </slide-x-left-transition>
            </div>
        </ion-list>

    </div>
</template>

<script>
    import PageTitle from '@/components/PageTitle.vue';
    import { mapState } from 'vuex';
    import goTo from '@/mixins/goto';

    export default{
        name: 'KnowledgeIndex',
        components: { PageTitle },
        mixins: [goTo],
        computed: {
            ...mapState({
                navigation: state => state.config.navigation ? state.config.navigation.knowledge : []
            }),
        },
        data(){
            return{
                show: false,
                // TODO REMOVE THIS - ONLY FOR TEST
                // navigation: [
                //     {
                //       "title":"Szkolenia",
                //       "route":"Trainings",
                //       "icon":'icon-knowledge',
                //       "content":"Zdobądź wiedzę o piwie oraz o różnych aspektach prowadzenia biznesu.",
                //       "disabled":false
                //     },
                //     {
                //       "title":"Nasze marki",
                //       "route":"Brands",
                //       "icon":'icon-hop',
                //       "content":"Poznaj nasze marki, których piwa są najchętniej wybierane przez Polaków.",
                //       "disabled":false
                //     },
                //     {
                //       "title":"Piwopedia",
                //       "route":"Wiki",
                //       "icon":'icon-beer1',
                //       "content":"Podziel się swoją wiedzą i podaj pomocną dłoń tym, którzy dopiero poznają świat gastronomii!",
                //       "disabled":false
                //     },
                //     {
                //       "title":"Foodpairing",
                //       "route":"Foodpairing",
                //       "icon":'icon-cutlery-cross',
                //       "content":"Jak dobierać piwo do potraw? Sprawdź, który wariant Książęcego pasuje do serwowanego jedzenia.",
                //       "disabled":false
                //     }
                //   ],
            }
        },
        mounted(){
            this.show = true;
        }
    }
</script>

<style lang="scss" scoped>
    ion-item,
    ion-list{
        --background: #f2f2f2;
    }
    ion-list{
        padding: 0;
    }
</style>
